<template>
    <div class="container-fluid pt-2">
        <div class="row">
            <div class="col-md-4 col-sm-12">
                <div class="text-left py-3">
                    <h3 class="text-weight-900 text-primary">Bulk Restock</h3>
                    <small v-if="draft.savedAt" class="text-muted"><i class="bi bi-cloud-check"></i> Draft saved {{ formatTime(draft.savedAt) }}</small>
                </div>
            </div>
            <!-- Unfinished restocks, autosaved (like stock taking) -->
            <div v-if="drafts.length" class="col-12 mb-3">
                <h6 class="mb-2">Saved drafts</h6>
                <div class="table-responsive">
                    <table class="table table-sm mb-0">
                        <thead><tr><th>Saved</th><th>By</th><th class="text-right">Items</th><th class="text-right">Total</th><th></th></tr></thead>
                        <tbody>
                            <tr v-for="d in drafts" :key="d.id" :class="{ 'table-active': d.id === draft.id }">
                                <td>{{ formatTime(d.updated_at) }}</td>
                                <td class="text-capitalize">{{ d.user ? d.user.name : '—' }}</td>
                                <td class="text-right">{{ d.item_count }}</td>
                                <td class="text-right">{{ Number(d.total).toLocaleString() }}</td>
                                <td class="text-right text-nowrap">
                                    <button v-if="d.id !== draft.id" class="btn btn-primary btn-sm" @click="continueDraft(d.id)">Continue</button>
                                    <span v-else class="text-muted mr-2">Open</span>
                                    <button class="btn btn-outline-danger btn-sm" @click="discardDraft(d.id)">Discard</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="requisition" class="col-12">
                <div class="alert alert-secondary d-flex justify-content-between align-items-center flex-wrap">
                    <span>
                        Receiving against LPO <strong>{{ requisition.requisition_code }}</strong>
                        — the outstanding quantities are already in the restock list. Adjust them to what actually arrived.
                    </span>
                    <a href="#" class="text-danger" @click.prevent="detachRequisition">Not for this LPO</a>
                </div>
            </div>
            <div class="col-md-8 col-sm-12">
                <div class="text-left py-3">
                    <button @click="openDrawer(true)" class="btn btn-primary py-2 px-3">View Restock List <span class="badge px-1 px-1 badge-light">{{ bulkRestock.itemsToRestock.length  }}</span></button>
                </div>
            </div>
        </div>
        <div>
            <form @submit.prevent class="form-inline py-2">
                <div class="input-group w-100 my-1">
                    <input type="text" ref="search_item_focus" class="form-control" v-model="searchItemToRestock" placeholder="Search Item">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="submit">
                                <i class="fa fa-search"></i>
                            </button>
                    </div>
                </div>
                <p> <small>Enter the item and select to add to list</small></p>
            </form>
            <!-- <ul class="list-group list-group-flush" style="z-index: 999 !important;">
                    <li @click="searchItemAddToList(item)" v-for="item in itemsSearched" class="list-group-item list-search-item text-primary">
                        {{ item.product }}
                    </li>
                </ul> -->
        </div>
        <div style="margin-bottom: 5em;">
            <table class="table table-sm table-striped table-hover">
                <thead>
                    <td>#</td>
                    <td>Item</td>
                    <td>Current Buying Price</td>
                    <td>In stock</td>
                </thead>
                <tbody>
                    <tr v-if="item.is_service !=1" v-for="(item,index) in filterItemsToRestock" @click="toggleRestockItem(item)" :class="{ 'table-active': bulkRestock.itemsToRestock.includes(item) }">
                        <td><input type="checkbox" :value="item" v-model="bulkRestock.itemsToRestock" @click.stop /></td>
                        <td>{{ item.product }}</td>
                        <td>{{ item.wholesale_ppu ?? 0 }}</td>
                        <td>{{ item.remaining_units }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- Restock list: a side drawer while picking items; expands to the full form. -->
        <b-sidebar v-model="drawer.open" right shadow no-header :width="drawer.expanded ? '100%' : '380px'"
            :backdrop="drawer.expanded" sidebar-class="restock-drawer" @hidden="drawer.expanded = false">
            <div class="h-100" @mouseenter="keepDrawer" @click="keepDrawer">
            <!-- Compact: what is in the list -->
            <div v-if="!drawer.expanded" class="d-flex flex-column h-100">
                <div class="d-flex align-items-center justify-content-between px-3 py-3 border-bottom">
                    <h5 class="mb-0 text-primary">Restock list <span class="badge badge-primary ml-1">{{ bulkRestock.itemsToRestock.length }}</span></h5>
                    <button type="button" class="btn btn-link text-secondary p-0" @click="drawer.open = false" aria-label="Close"><i class="bi bi-x-lg"></i></button>
                </div>
                <div class="flex-grow-1 overflow-auto">
                    <p v-if="!bulkRestock.itemsToRestock.length" class="text-muted text-center py-5 px-3 mb-0">Tick items on the page to add them here.</p>
                    <div v-for="(item, index) in bulkRestock.itemsToRestock" :key="item.id" class="restock-drawer-item d-flex align-items-center px-3 py-2 border-bottom" @click="openDrawer(true)">
                        <div class="flex-grow-1">
                            <div class="font-weight-bold text-dark">{{ item.product }}
                                <span v-if="item.track_lots" class="badge badge-secondary ml-1">lots</span>
                            </div>
                            <small class="text-muted">{{ item.remaining_units }} in stock · buying {{ item.wholesale_ppu ?? 0 }}</small>
                        </div>
                        <a href="#" class="text-danger h5 mb-0 ml-2" title="Remove" @click.stop.prevent="removeFromArray(index)"><i class="bi bi-x-circle"></i></a>
                    </div>
                </div>
                <div class="p-3 border-top restock-drawer-footer">
                    <button type="button" class="btn btn-primary btn-block" :disabled="!bulkRestock.itemsToRestock.length" @click="openDrawer(true)">Enter quantities &amp; receive</button>
                </div>
            </div>

            <!-- Expanded: the restock form -->
            <div v-else class="container py-3">
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <button type="button" class="btn btn-link px-0" @click="drawer.expanded = false"><i class="bi bi-arrow-left mr-1"></i>Back to list</button>
                    <h5 class="mb-0 text-primary">Restock {{ bulkRestock.itemsToRestock.length }} item(s)</h5>
                    <button type="button" class="btn btn-link text-secondary px-0" @click="drawer.open = false" aria-label="Close"><i class="bi bi-x-lg"></i></button>
                </div>
            <form @submit.prevent class="form-inline py-2">
                <div class="input-group w-100 my-1">
                    <input type="text" ref="search_item_focus" class="form-control" v-model="searchItemToRestock" placeholder="Search Item">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="submit">
                                <i class="fa fa-search"></i>
                            </button>
                    </div>
                </div>
                <p> <small>Enter the item and select to add to list</small></p>
            </form>
            <div v-if="showSearchTable">
                <table class="table table-sm table-striped table-hover">
                    <thead>
                        <td>#</td>
                        <td>Item</td>
                        <td>Current Buying Price</td>
                        <td>In stock</td>
                    </thead>
                    <tbody>
                        <tr v-if="item.is_service != 1" v-for="(item, index) in filterItemsToRestock.slice(0, 3)" :key="index" @click="toggleRestockItem(item)" :class="{ 'table-active': bulkRestock.itemsToRestock.includes(item) }">
                            <td><input type="checkbox" :value="item" v-model="bulkRestock.itemsToRestock" @click.stop /></td>
                            <td>{{ item.product }}</td>
                            <td>{{ item.wholesale_ppu ?? 0 }}</td>
                            <td>{{ item.remaining_units }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-center">
                <div v-if="supplierDetails.selectedSupplier.supplier">
                    <p class="text-capitalize"><span class="text-bold">Supplier: </span>{{ supplierDetails.selectedSupplier.supplier }}. <a @click="resetSupplier" href="#">Change</a> </p>
                </div>
                <div v-else>
                    <button class="btn btn-block btn-outline-dark" @click="openSupplierSelectionModal">
                                    <span class="h5">
                                        <i class="bi bi-person-circle"></i>
                                    </span>
                                    <span class="text-danger">
                                        Select/Add Supplier
                                    </span>
                                    </button>
                </div>
            </div>
            <!-- Optional columns: show only what you're changing (remembered on this device) -->
            <div class="d-flex flex-wrap align-items-center py-2">
                <span class="text-muted mr-2">Also change:</span>
                <div class="btn-group" role="group">
                    <button type="button" class="btn" :class="cols.sp ? 'btn-primary' : 'btn-outline-secondary'" @click="toggleCol('sp')">
                        <i class="bi" :class="cols.sp ? 'bi-check2-square' : 'bi-square'"></i> Selling price
                    </button>
                    <button type="button" class="btn" :class="cols.wsp ? 'btn-primary' : 'btn-outline-secondary'" @click="toggleCol('wsp')">
                        <i class="bi" :class="cols.wsp ? 'bi-check2-square' : 'bi-square'"></i> Wholesale price
                    </button>
                </div>
            </div>
            <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <td>Item</td>
                    <td>Qty
                        <p><small class="text-danger">Enter quantities as is on the receipt</small></p>
                    </td>
                    <td>Buying Price
                        <p><small class="text-danger">You can change B.P by editing below</small></p>
                    </td>
                    <td v-if="cols.sp">Selling Price</td>
                    <td v-if="cols.wsp">Wholesale Price</td>
                    <td>Total</td>
                </thead>
                <tbody>
                    <tr v-for="(itemSelected,index) in bulkRestock.itemsToRestock">
                        <td>{{ itemSelected.product }}
                            <select v-if="itemSelected.has_variants" class="form-control form-control-sm mt-1" v-model="itemSelected.variant_id" @change="onBulkVariantChange(itemSelected)" required>
                                <option value="" disabled>Select variant</option>
                                <option v-for="v in (restockListVariants[itemSelected.id] || [])" :key="v.id" :value="v.id">{{ v.name }} — {{ v.remaining_units }} in stock</option>
                            </select>
                            <select v-if="bulkUnitsFor(itemSelected).length > 1" class="form-control form-control-sm mt-1" v-model="itemSelected.unit_id">
                                <option value="">{{ (bulkUnitsFor(itemSelected).find(u => u.is_base_unit) || {}).unit_name || 'Base unit' }} (base)</option>
                                <option v-for="u in bulkUnitsFor(itemSelected).filter(u => !u.is_base_unit)" :key="u.id" :value="u.id">{{ u.unit_name }} (x{{ u.conversion_factor }})</option>
                            </select>
                            <div v-if="itemSelected.track_lots" class="restock-lot mt-2">
                                <span class="badge badge-secondary mb-1">lots</span>
                                <input v-model="itemSelected.supplier_lot_number" class="form-control mb-1" placeholder="Supplier lot no." />
                                <date-range-picker :single-date-picker="true" :auto-apply="true" :ranges="false" :append-to-body="true"
                                    :date-range="lotDate(itemSelected, 'expiry_date')" @update="r => setLotDate(itemSelected, 'expiry_date', r)" class="custom-width-datepicker">
                                    <template #input="picker">
                                        <span v-if="picker.startDate" class="text-dark">Expires {{ formatPickerDate(picker.startDate) }}</span>
                                        <span v-else class="text-muted"><i class="bi bi-calendar-event mr-1"></i>Expiry date</span>
                                    </template>
                                </date-range-picker>
                                <a v-if="!itemSelected.showRetest" href="#" class="small d-block mt-1" @click.prevent="$set(itemSelected, 'showRetest', true)">+ Retest date</a>
                                <date-range-picker v-else :single-date-picker="true" :auto-apply="true" :ranges="false" :append-to-body="true"
                                    :date-range="lotDate(itemSelected, 'retest_date')" @update="r => setLotDate(itemSelected, 'retest_date', r)" class="custom-width-datepicker mt-1">
                                    <template #input="picker">
                                        <span v-if="picker.startDate" class="text-dark">Retest {{ formatPickerDate(picker.startDate) }}</span>
                                        <span v-else class="text-muted"><i class="bi bi-calendar-event mr-1"></i>Retest date</span>
                                    </template>
                                </date-range-picker>
                            </div>
                        </td>
                        <td><input v-model="itemSelected.restockQty" class="form-control border-right-0 border-left-0 border-top-0 bg-transparent" type="text" required/></td>
                        <td><input v-model="itemSelected.wholesale_ppu" class="form-control border-right-0 border-left-0 border-top-0 bg-transparent" /></td>
                        <td v-if="cols.sp"><input v-model="itemSelected.ppu" class="form-control border-right-0 border-left-0 border-top-0 bg-transparent" /></td>
                        <td v-if="cols.wsp"><input v-model="itemSelected.wholesale_sp" class="form-control border-right-0 border-left-0 border-top-0 bg-transparent" placeholder="Wholesale" /></td>
                        <td>{{ itemSelected.totalBuying}} </td>
                        <td><a @click="removeFromArray(index)" class="text-danger h5"><i class="bi bi-x-circle"></i></a></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td v-if="cols.sp"></td>
                        <td v-if="cols.wsp"></td>
                        <td>
                            <h5>Total:</h5>
                        </td>
                        <td>
                            <h5>{{ totalBuyingSum }}</h5>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
            <small>You can add an item that is not in your inventory as well</small>
            <p><a v-b-modal="'new-item-modal'" class="text-c">Create an Item</a></p>
            <hr />
            <div class="container">
                 <div class="form-check mt-2">
                <input class="form-check-input" type="checkbox" v-model="bulkRestock.changeBuyingPriceImmediately" id="defaultCheck1">
                <label class="form-check-label" for="defaultCheck1">
                       I want to apply this new buying price immediately
                    </label>
                <p>
                    <small class="text-danger">Leaving this will update buying price after old stock is sold out</small>
                </p>
                </div>

                <div v-if="bulkRestock.changeBuyingPriceImmediately">

                <div class="form-check mt-2">
                    <input class="form-check-input" type="checkbox" v-model="bulkRestock.apply_buying_price_all_branches" id="applyBuyingAllBranches">
                    <label class="form-check-label" for="applyBuyingAllBranches">Apply buying price to all branches</label>
                </div>
                <div class="form-check mt-2">
                    <input class="form-check-input" type="checkbox" v-model="bulkRestock.apply_selling_price_all_branches" id="applySellingAllBranches">
                    <label class="form-check-label" for="applySellingAllBranches">Apply selling price to all branches</label>
                </div>
                </div>
                <hr />
                <div class="form-group">
                    <label>Supplier Invoice No./Delivery Note</label>
                    <input class="form-control" placeholder="e.g INV-01"  v-model="bulkRestock.receipt_number" type="text" />
                </div>
                <div class="form-group">
                    <label>Invoice Date</label>
                    <date-range-picker :single-date-picker="true" :auto-apply="true" :ranges="false" :append-to-body="true" v-model="invoiceDatePicker" class="custom-width-datepicker">
                        <template #input="picker">
                            <span v-if="picker.startDate" class="text-dark">{{ formatPickerDate(picker.startDate) }}</span>
                            <span v-else class="text-muted"><i class="bi bi-calendar-event mr-1"></i>Select date</span>
                        </template>
                    </date-range-picker>
                </div>
                <div class="form-group">
                    <label>Amount paid</label>
                    <p><small>This is to track debt</small></p>
                    <input class="form-control"  v-model="bulkRestock.amount_paid" type="text" />
                </div>
                <div class="form-group">
                    <label>Account</label>
                    <p><small>Optional — which chart-of-accounts account this purchase should post to. Leave as default to use Inventory.</small></p>
                    <b-form-select class="border" v-model="bulkRestock.account_id" :options="accountSelectOptions"></b-form-select>
                </div>

                <p>Add files/image of Receipt or Goods Received Note</p>
                <input class="d-none" v-model="bulkRestock.receiptFile" type="hidden" />
                <vue-dropzone ref="myVueDropzone" id="customdropzone" :options="dropzoneOptionsProductImages" :useCustomSlot="true" v-on:vdropzone-success="uploadImageSuccess" v-on:vdropzone-error="uploadError" v-on:vdropzone-removed-file="fileRemoved">
                    <div class="dropzone-custom-content">
                        <div class="text-center">
                            <p class="text-secondary"> <i class="fas fa-file-alt"></i></p>
                            <p><small class="dropzone-custom-title text-secondary py-2">Drag & Drop</small></p>
                            <a class="btn btn-outline-secondary" href="#">Choose File</a>
                            <p><small class="text-secondary">Max file size 10MB</small></p>
                        </div>
                    </div>
                </vue-dropzone>
                <!-- <button @click="openCamera">Open Camera</button> -->
                <input type="file" ref="cameraInput" accept="image/*" capture="camera" style="display: none;" @change="onCameraChange">
                <div class="text-center">
                    <div class="py-2">
                        <button class="btn btn-primary" v-b-modal="'verify-restock-b4-submit'">Submit New Stock</button>
                    </div>
                </div>
            </div>
            </div>
            </div>
        </b-sidebar>

        <!-- Edge tab: brings the list back after a peek -->
        <button v-if="!drawer.open && bulkRestock.itemsToRestock.length" type="button" class="restock-drawer-tab btn btn-primary"
            @click="openDrawer(false)" title="Show restock list">
            <i class="bi bi-chevron-left"></i>
            <span class="restock-drawer-tab-label">Restock list</span>
            <span class="badge badge-light">{{ bulkRestock.itemsToRestock.length }}</span>
        </button>
        <b-modal id="verify-restock-b4-submit" hide-footer>
            <div class="text-center">
                <div class="py-4">
                    <p>Are you sure you want to restock these items?</p>
                    <a @click="reviewRestock" class="btn btn-primary" :class="{ 'disabled': !confirmIsNotComplete }" :disabled="!confirmIsNotComplete">
                            Yes! Restock
                            </a>
                </div>
            </div>
        </b-modal>
        <b-modal ref="supplierSelectionModal" hide-footer>
            <p>Supplier details</p>
            <small>To add or search supplier just type the name of supplier</small>
            <div v-if="supplierDetails.selectedSupplier.supplier">
                <p class="text-capitalize"><span class="text-bold">Supplier: </span>{{ supplierDetails.selectedSupplier.supplier }}. <a @click="resetSupplier" href="#">Change</a> </p>
            </div>
            <div class="form-group">
                <input class="form-control" v-model="supplierDetails.searchTerm" placeholder="Supplier name">
                <div v-if="supplierDetails.searchTable == true">
                    <div v-if="supplierDetails.filteredSuppliers.length > 0">
                        <table class="table table-striped table-sm">
                            <thead>
                                <th>Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                            </thead>
                            <tbody>
                                <tr class="text-dark text-capitalize underline text-sm" v-for="supplier in supplierDetails.filteredSuppliers" :key="supplier.id" @click="rowSelectSupplier(supplier)">
                                    <td class="text-primary underline-primary">{{ (supplier.supplier) ? supplier.supplier : '' }}</td>
                                    <td>{{ (supplier.phone) ? supplier.phone :'' }}</td>
                                    <td>{{ (supplier.email) ? supplier.email :'' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <a @click="openAddSupplierModal" href="#">Create supplier - {{ supplierDetails.searchTerm }}</a>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal id="new-item-modal" hide-footer>
            <form v-if="itemsForm.is_Service === false" class="mb-5 form-signin-product" @submit.prevent="submitProduct">
                <!-- <div class="container">
                                            <div class="row align-items-center h-100">
                                                <div class="col-12 mx-auto">
                                                    <div class="jumbotron">
                                                        <fileuploader></fileuploader>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                <div class="text-center">
                    <h5 class="text-dark text-left text-weight-400 pb-2">Product Details</h5>
                </div>
                <div class="form-group">
                    <label>Item Name</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Item Title" v-model="itemsForm.title" required/>
                </div>
                <div class="form-group">
                    <label>Buying Price</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Price per unit" v-model="itemsForm.wholesale_ppu" required/>
                    <small class="pl-3 text-dark">Wholesale Price per unit</small>
                </div>
                <div class="form-group">
                    <label>Selling Price</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Price per unit" v-model="itemsForm.ppu" required/>
                    <small class="pl-3 text-dark">Retail Price per unit</small>
                </div>
                <div class="form-group">
                    <label>Wholesale Selling Price</label>
                    <input type="text" class="form-control border" placeholder="Optional" v-model="itemsForm.wholesale_sp" />
                    <small class="pl-3 text-dark">Leave blank to use the selling price</small>
                </div>
                <div class="form-group">
                    <label>Measuring Unit</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Measuring Unit" v-model="itemsForm.measuring_unit" required/>
                    <small class="pl-3 text-dark">Measuring Unit (Kgs,Pieces,Litres etc)</small>
                </div>
                <div class="form-group">
                    <label>SKU - store keeping unit</label>
                    <input type="text" class="form-control border" placeholder="sku" v-model="itemsForm.sku" />
                    <small class="pl-3 text-dark">Store keeping unit</small>
                </div>
                <div class="form-group">
                    <label>Item Count (Quantities)</label><span class="text-danger">*</span>
                    <input type="text" class="form-control border" placeholder="Quantity" v-model="itemsForm.qty" required/>
                    <small class="pl-3 text-dark">eg. 10</small>
                </div>
                <div class="form-group">
                    <label>Item Category</label><span class="text-danger">*</span>
                    <p class="text-danger" v-if="itemsForm.categorySelectError !==''">{{ itemsForm.categorySelectError }}</p>
                    <p class="text-danger" v-if="categoryOptions.length === 1">Seems you don't have any category - <a href="#" @click="createProductCatModal">Create One</a></p>
                    <b-form-select v-model="itemsForm.selectedCategory" :options="categoryOptions">
                    </b-form-select>
                    <!-- <p class="text-dark" v-if="categoryOptions.length > 1">Can't see a category - <a href="#" @click="createProductCatModal">Add One</a></p> -->
                </div>
                <div v-if="itemsForm.added" class="alert alert-primary py-2">{{ itemsForm.added }} added to the restock list. Add another, or close.</div>
                <div v-if="itemsForm.error" class="alert alert-danger py-2">{{ itemsForm.error }}</div>
                <button class="btn btn-block btn-primary" type="submit" :disabled="itemsForm.saving">
                    <span v-if="itemsForm.saving" class="spinner-border spinner-border-sm mr-1"></span>Create Item
                </button>
            </form>
        </b-modal>
        <!-- Review before saving: supplier and payment -->
        <b-modal ref="reviewModal" title="Before you save" hide-footer>
            <div class="form-group">
                <label class="font-weight-bold">Supplier</label>
                <div v-if="supplierDetails.selectedSupplier.supplier" class="d-flex justify-content-between align-items-center">
                    <span class="text-capitalize">{{ supplierDetails.selectedSupplier.supplier }}</span>
                    <a href="#" @click.prevent="openSupplierSelectionModal">Change</a>
                </div>
                <div v-else>
                    <p class="text-muted mb-2">Adding the supplier lets you track what you owe them and see purchases per supplier.</p>
                    <button type="button" class="btn btn-outline-primary btn-block" @click="openSupplierSelectionModal">
                        <i class="bi bi-person-plus"></i> Select / add supplier
                    </button>
                </div>
            </div>
            <div class="form-group">
                <label class="font-weight-bold">Amount paid now</label>
                <input class="form-control" type="number" min="0" step="0.01" v-model.number="bulkRestock.amount_paid" />
                <small class="text-muted d-block">Total {{ Number(totalBuyingSum).toLocaleString() }}.
                    <span v-if="Number(bulkRestock.amount_paid) < Number(totalBuyingSum)" class="text-danger">
                        {{ Number(totalBuyingSum - (bulkRestock.amount_paid || 0)).toLocaleString() }} will show as owed to the supplier.
                    </span>
                </small>
            </div>
            <button class="btn btn-primary btn-block" :disabled="!confirmIsNotComplete" @click="$refs.reviewModal.hide(); completeRestock()">
                {{ supplierDetails.selectedSupplier.supplier ? 'Save restock' : 'Save without a supplier' }}
            </button>
        </b-modal>

        <b-modal ref="newSupplierModal" id="new-supplier-modal" hide-footer static>
            <div class="container text-center">
                <div class="text-centre">
                    <h2 class="font-weight-bold ">Add New Supplier</h2>
                </div>
            </div>
            <div class="container py-3">
                <!-- Actual search box -->
                <form @submit.prevent="createNewSupplier">
                    <div class="form-group">
                        <label>Supplier name <span class="text-danger">*</span></label>
                        <input class="form-control" v-model="newSupplier.supplier" type="text" placeholder="Company name" required/>
                    </div>
                    <p class="mb-2"><small class="text-muted">Phone or email — <span class="text-danger">at least one is required</span></small></p>
                    <div class="form-group">
                        <label>Phone</label>
                        <vue-tel-input v-model="newSupplier.phone" :default-country="'KE'" :input-options="{ placeholder: 'E.g 0712345678', required: false }"></vue-tel-input>
                    </div>
                    <div class="form-group">
                        <label>Email</label>
                        <input class="form-control" v-model="newSupplier.email" type="email" placeholder="Email" />
                    </div>
                    <p class="mb-2"><small class="text-muted">Contact person (optional)</small></p>
                    <div class="form-row">
                        <div class="form-group col-6">
                            <input class="form-control" v-model="newSupplier.supplier_representatives.name" type="text" placeholder="Name" />
                        </div>
                        <div class="form-group col-6">
                            <vue-tel-input v-model="newSupplier.supplier_representatives.phone" :default-country="'KE'" :input-options="{ placeholder: 'E.g 0712345678', required: false }"></vue-tel-input>
                        </div>
                    </div>
                    <div v-if="newSupplier.error" class="alert alert-danger py-2">{{ newSupplier.error }}</div>
                    <div class="form-group pt-2">
                        <button class="btn btn-primary btn-block" :disabled="newSupplier.saving">Add Supplier</button>
                    </div>
                </form>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker';
import productCacheService from '../IndexDB/productCacheService';
    export default {
        components: {
            vueDropzone: vue2Dropzone,
            DateRangePicker
        },
        data() {
            return {
                drawer: { open: false, expanded: false, peekTimer: null },
                itemList: {},
                confirmIsNotComplete: true,
                drafts: [],
                draft: { id: null, savedAt: null, timer: null, loading: false },
                newSupplier: { supplier: '', email: '', phone: '', supplier_representatives: { name: '', phone: '' }, error: '', saving: false },
                showSearchTable: false,
                bulkRestock: {
                    itemsToRestock: [],
                    changeSellingPrice: false,
                    totalAmount: 0,
                    changeBuyingPriceImmediately: false,
                    apply_buying_price_all_branches: false,
                    apply_selling_price_all_branches: false,
                    receiptFile: [],
                    amount_paid: 0,
                    receipt_number: '',
                    due_date: '',
                    account_id: null,
                    requisition_id: null,
                },
                requisition: null,
                chartOfAccounts: [],
                itemsForm: {
                    selectedCategory: null,
                    title: '',
                    qty: '',
                    measuring_unit: '',
                    wholesale_ppu: '',
                    wholesale_sp: '',
                    ppu: '',
                    categorySelectError: '',
                    is_Service: false,
                    sku: '',
                    saving: false,
                    added: '',
                    error: '',
                },
                // Optional table columns, remembered on this device.
                cols: (() => {
                    try { return Object.assign({ sp: false, wsp: false }, JSON.parse(localStorage.getItem('bulkRestockCols') || '{}')); }
                    catch (e) { return { sp: false, wsp: false }; }
                })(),
                categoryOptions: [{
                    value: null,
                    text: 'Select Category'
                }],
                dropzoneOptionsProductImages: {
                    url: "/api/files",
                    addRemoveLinks: true,
                    maxFiles: 5,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                },
                searchItemToRestock: '',
                // Product Variations + Units/Packaging: keyed by product id
                // (variants) or by "product:<id>"/"variant:<id>" (units) -
                // see docs/product-variations-units-implementation-plan.md
                // Part 16c.
                restockListVariants: {},
                restockListUnits: {},
                itemsSearched: {},
                supplierDetails: {
                    supplier: {
                        email: '',
                        phone: '',
                        supplier: '',
                        supplier_representatives: {
                            name: '',
                            email: '',
                            phone: ''
                        },
                    },
                    searchTerm: '',
                    searchTable: false,
                    filteredSuppliers: {},
                    selectedSupplier: {}
                }
            }
        },
        mounted() {
            this.getAllProducts().then(() => this.loadRequisition())
            this.loadDrafts()
            this.loadAccounts()
            this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
                if (modalId === 'new-item-modal') {
                    this.resetItemsForm();
                    this.getCategories()
                }
            })
        },
        created() {
            this.setDefaultRestockQty();
              this.bulkRestock.amount_paid = this.totalBuyingSum

        },
        beforeDestroy() {
            clearTimeout(this.draft.timer);
            clearTimeout(this.drawer.peekTimer);
        },
        computed: {
            invoiceDatePicker: {
                get() { return { startDate: this.bulkRestock.due_date ? new Date(this.bulkRestock.due_date) : null }; },
                set(val) { this.bulkRestock.due_date = val && val.startDate ? moment(val.startDate).format('YYYY-MM-DD') : null; },
            },
            updatedItemsToRestock() {
                // Compute the totalBuying for each itemSelected
                this.bulkRestock.itemsToRestock.forEach(item => {
                    // Check for NaN or undefined values and set to default if needed
                    const restockQty = isNaN(item.restockQty) || item.restockQty === undefined ? 0 : item.restockQty;
                    const wholesale_ppu = isNaN(item.wholesale_ppu) || item.wholesale_ppu === undefined ? 0 : item.wholesale_ppu;
                    this.$set(item, 'totalBuying', restockQty * wholesale_ppu);
                });
                return this.bulkRestock.itemsToRestock;
            },
          filterItemsToRestock() {
            return Object.values(this.itemList).filter(item => {
                const search = this.searchItemToRestock.toLowerCase();

                const sku = item.sku ? item.sku.toLowerCase() : "";
                const product = item.product.toLowerCase() || '';

                // An empty search must not "match" every product without a SKU
                // (that silently filled the list on page load, with duplicates).
                const isSkuMatch = search !== '' && sku === search;
                const isProductMatch = product.includes(search);

                if (isSkuMatch && !this.bulkRestock.itemsToRestock.includes(item)) {
                    this.bulkRestock.itemsToRestock.push(item); // scanned / typed barcode adds the item
                }

                return isSkuMatch || isProductMatch;
            });
        },
            totalBuyingSum() {
                return this.bulkRestock.itemsToRestock.reduce((total, item) => {
                    // Check for NaN or undefined values and set to default if needed
                    const restockQty = isNaN(item.restockQty) || item.restockQty === undefined ? 1 : item.restockQty;
                    const wholesale_ppu = isNaN(item.wholesale_ppu) || item.wholesale_ppu === undefined ? 0 : item.wholesale_ppu;
                    const totalBuying = restockQty * wholesale_ppu;
                    // Add totalBuying to the accumulator
                    return parseFloat((total + totalBuying).toFixed(2));
                }, 0);
            },
            accountSelectOptions() {
                return [
                    { value: null, text: 'Default (Inventory)' },
                    ...this.chartOfAccounts
                        .filter(g => (g.accounts || []).length > 0)
                        .map(g => ({
                            label: g.name,
                            options: g.accounts.map(a => ({ value: a.id, text: a.name })),
                        })),
                ];
            },
        },
        watch: {
            // Autosave the list (debounced) while someone works on it.
            bulkRestock: { deep: true, handler() { this.scheduleDraftSave(); } },
            'supplierDetails.selectedSupplier'() { this.scheduleDraftSave(); },
            // Picking an item peeks the list in from the right; emptying it closes the drawer.
            'bulkRestock.itemsToRestock.length'(now, before) {
                if (now > (before || 0)) this.peekDrawer();
                if (now === 0) { this.keepDrawer(); this.drawer.expanded = false; this.drawer.open = false; }
            },
            'bulkRestock.itemsToRestock': {
                handler(newVal, oldVal) {
                    // Recalculate totals when itemsToRestock changes
                    newVal.forEach(item => {
                        // Check for NaN or undefined values and set to default if needed
                        const restockQty = isNaN(item.restockQty) || item.restockQty === undefined ? 1 : item.restockQty;
                        const wholesale_ppu = isNaN(item.wholesale_ppu) || item.wholesale_ppu === undefined ? 0 : item.wholesale_ppu;
                        this.$set(item, 'totalBuying', parseFloat((restockQty * wholesale_ppu).toFixed(2)));
                        this.showSearchTable = false;

                        if (item.variant_id === undefined) this.$set(item, 'variant_id', '');
                        if (item.unit_id === undefined) this.$set(item, 'unit_id', '');

                        if (item.has_variants && !this.restockListVariants[item.id]) {
                            this.loadItemVariants(item);
                        } else if (!item.has_variants && !this.restockListUnits['product:' + item.id]) {
                            this.loadItemUnits('product', item.id);
                        }
                    })
                },
                deep: true
            },
            'supplierDetails.searchTerm': function() {
                if (this.supplierDetails.searchTerm.length > 0) {
                    this.supplierDetails.searchTable = true
                    this.searchSupplier();
                } else {
                    this.supplierDetails.searchTable = false
                }
            },
            totalBuyingSum(newVal, oldVal) {
                    this.bulkRestock.amount_paid = newVal;
                },
            searchItemToRestock(before, after) {
                this.showSearchTable = true;
            }
        },
        methods: {
            openDrawer(expanded) {
                this.keepDrawer();
                this.drawer.expanded = !!expanded;
                this.drawer.open = true;
            },
            // Picking an item shows the list briefly, then tucks it away behind the edge tab.
            peekDrawer() {
                if (this.drawer.open && !this.drawer.peekTimer) return; // opened on purpose: leave it
                this.drawer.expanded = false;
                this.drawer.open = true;
                clearTimeout(this.drawer.peekTimer);
                this.drawer.peekTimer = setTimeout(() => {
                    this.drawer.peekTimer = null;
                    if (!this.drawer.expanded) this.drawer.open = false;
                }, 1800);
            },
            // Any interaction during a peek keeps the drawer open.
            keepDrawer() {
                clearTimeout(this.drawer.peekTimer);
                this.drawer.peekTimer = null;
            },
            lotDate(item, field) {
                return { startDate: item[field] ? new Date(item[field]) : null, endDate: item[field] ? new Date(item[field]) : null };
            },
            // Lot dates travel with the item (expiry_date / retest_date), which the purchase API stores on the new lot.
            setLotDate(item, field, range) {
                this.$set(item, field, range && range.startDate ? moment(range.startDate).format('YYYY-MM-DD') : null);
            },
            formatPickerDate(d) {
                if (!d) return '';
                return new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
            },
            async loadItemVariants(item) {
                try {
                    const result = await axios.get(`/api/products/${item.id}/variants`);
                    this.$set(this.restockListVariants, item.id, result.data.variants || []);
                } catch (e) {
                    console.error(e);
                }
            },
            async loadItemUnits(ownerType, ownerId) {
                const key = ownerType + ':' + ownerId;
                try {
                    const url = ownerType === 'variant'
                        ? `/api/product-variants/${ownerId}/units`
                        : `/api/products/${ownerId}/units`;
                    const result = await axios.get(url);
                    this.$set(this.restockListUnits, key, result.data || []);
                } catch (e) {
                    console.error(e);
                }
            },
            onBulkVariantChange(item) {
                item.unit_id = '';
                this.$set(this.restockListUnits, 'product:' + item.id, []);
                if (item.variant_id) {
                    this.loadItemUnits('variant', item.variant_id);
                }
            },
            bulkUnitsFor(item) {
                const key = item.has_variants
                    ? (item.variant_id ? 'variant:' + item.variant_id : null)
                    : 'product:' + item.id;
                return key ? (this.restockListUnits[key] || []) : [];
            },
            toggleCol(key) {
                this.cols[key] = !this.cols[key];
                try { localStorage.setItem('bulkRestockCols', JSON.stringify(this.cols)); } catch (e) { /* storage unavailable */ }
            },
            resetItemsForm(keep = {}) {
                Object.assign(this.itemsForm, {
                    selectedCategory: null, title: '', qty: '', measuring_unit: '', wholesale_ppu: '', wholesale_sp: '',
                    ppu: '', categorySelectError: '', is_Service: false, sku: '', saving: false, added: '', error: '',
                }, keep);
            },
            async submitProduct() {
                this.itemsForm.added = '';
                this.itemsForm.error = '';
                if (this.itemsForm.selectedCategory === null) {
                    this.itemsForm.categorySelectError = 'You need to select a category';
                    return;
                }
                this.itemsForm.saving = true;
                try {
                    const { title, qty, wholesale_ppu, wholesale_sp, ppu, selectedCategory, is_Service, sku, measuring_unit } = this.itemsForm;
                    const results = await axios.post('/api/addprod', {
                        title, qty, wholesale_ppu, ppu, selectedCategory, is_Service, sku,
                        wholesale_sp: wholesale_sp || ppu,
                        measunit: measuring_unit,
                    });
                    const product = {
                        ...results.data.product,
                        restockQty: results.data.product.remaining_units,
                        dontAdd: 1, // created with its quantity already - not restocked again
                    };
                    this.bulkRestock.itemsToRestock.push(product);
                    // Clear for the next item; keep the category, often the same.
                    this.resetItemsForm({ selectedCategory, added: product.product });
                } catch (e) {
                    this.itemsForm.saving = false;
                    this.itemsForm.error = e.response?.data?.message || 'Could not create the item. Please try again.';
                }
            },
            createProductCatModal() {
            },
            getCategories() {
                axios.get('/api/items-category').then(results => {
                    // Rebuilt on every open: appending made the list grow each time.
                    this.categoryOptions = [{ value: null, text: 'Select Category' }];
                    $.each(results.data, (key, value) => {
                        const itemCat = {
                            value: value.id,
                            text: value.name
                        }
                        this.categoryOptions.push(itemCat)
                    })
                }).catch(errors => {
                    console.log(errors)
                })
            },
            removeFromArray(index) {
                if (index > -1) {
                    this.bulkRestock.itemsToRestock.splice(index, 1);
                }
            },
            // /bulk-restock?requisition=<id>: prefill from an approved requisition's
            // outstanding lines, and record the purchase against it.
            async loadRequisition() {
                const id = new URLSearchParams(window.location.search).get('requisition');
                if (!id) return;
                try {
                    const { data } = await axios.get(`/api/requisitions/${id}`);
                    if (!['approved', 'partially_received'].includes(data.status)) {
                        this.$toasts.push({ type: 'error', message: `Requisition ${data.requisition_code} is ${data.status.replace('_', ' ')} — nothing to receive.` });
                        return;
                    }
                    this.requisition = data;
                    this.bulkRestock.requisition_id = data.id;
                    // An LPO names its supplier and agreed costs: start from those.
                    if (data.supplier) {
                        this.supplierDetails.selectedSupplier = data.supplier;
                        this.bulkRestock.supplier = data.supplier.id;
                    }
                    const products = Object.values(this.itemList);
                    (data.items || []).filter(i => Number(i.outstanding_quantity) > 0).forEach(i => {
                        const product = products.find(p => p.id === i.product_id);
                        if (product && !this.bulkRestock.itemsToRestock.includes(product)) {
                            this.$set(product, 'restockQty', Number(i.outstanding_quantity));
                            if (i.unit_cost !== null && i.unit_cost !== undefined) this.$set(product, 'wholesale_ppu', Number(i.unit_cost));
                            this.bulkRestock.itemsToRestock.push(product);
                        }
                    });
                    if (this.bulkRestock.itemsToRestock.length) this.openDrawer(true);
                } catch (e) {
                    this.$toasts.push({ type: 'error', message: 'Could not load the requisition.' });
                }
            },
            detachRequisition() {
                this.requisition = null;
                this.bulkRestock.requisition_id = null;
            },
            async getAllProducts() {
                await axios.get('/api/only-products').then(results => {
                    this.itemList = results.data
                }).catch(error => {})
            },
            async loadAccounts() {
                try {
                    const { data } = await axios.get('/api/accounts-for-selection')
                    this.chartOfAccounts = Array.isArray(data) ? data : []
                } catch (e) {
                    // silent — picker just stays on "Default"
                }
            },
            openCamera() {
                const videoElement = document.createElement('video');
                const canvasElement = document.createElement('canvas');
                const constraints = {
                    video: true,
                };
                navigator.mediaDevices.getUserMedia(constraints)
                    .then((stream) => {
                        videoElement.srcObject = stream;
                        videoElement.play();
                        const captureButton = document.createElement('button');
                        captureButton.innerText = 'Capture';
                        document.body.appendChild(videoElement);
                        document.body.appendChild(captureButton);
                        captureButton.addEventListener('click', () => {
                            canvasElement.width = videoElement.videoWidth;
                            canvasElement.height = videoElement.videoHeight;
                            canvasElement.getContext('2d').drawImage(videoElement, 0, 0);
                            this.image = canvasElement.toDataURL('image/png');
                            this.file = this.dataURLtoFile(this.image, 'captured.png');
                            this.$refs.myVueDropzone.manuallyAddFile(this.file); // Add the captured image to VueDropzone
                            stream.getTracks().forEach(track => track.stop());
                            document.body.removeChild(videoElement);
                            document.body.removeChild(captureButton);
                        });
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            onCameraChange(event) {
                const file = event.target.files[0];
                if (file) {
                    this.$refs.myVueDropzone.manuallyAddFile(file); // Add the selected file to VueDropzone
                }
            },
            uploadSuccess(file, response) {
                this.$toasts.push({
                    type: 'success',
                    message: "File uploaded successfully",
                });
            },
            uploadImageSuccess(file, response) {
                this.$toasts.push({
                    type: 'success',
                    message: "File uploaded successfully",
                });
                this.bulkRestock.receiptFile.push(response.file)
            },
            uploadError(file, message) {
                this.$toasts.push({
                    type: 'error',
                    message: "There was an error uploading your file",
                });
            },
            fileRemoved(file) {
                if (file.serverResponse) {
                    this.bulkRestock.receiptFile = this.bulkRestock.receiptFile.filter(f => f !== file.serverResponse);
                } else {
                    // If no serverResponse, match using file name or other attributes
                    const fileResponse = JSON.parse(file.xhr.response);
                    const fileName = fileResponse.file;
                    // Find the index of the file name in receiptFile array
                    const index = this.bulkRestock.receiptFile.findIndex(f => f === fileName);
                    if (index > -1) {
                        // Remove the file from the array
                        this.bulkRestock.receiptFile.splice(index, 1);
                    }
                }
            },
            setDefaultRestockQty() {
                this.bulkRestock.itemsToRestock.forEach(item => {
                    if (item.restockQty === undefined || item.restockQty === null) {
                        this.$set(item, 'restockQty', 1);
                    }
                });
            },
            async openSupplierSelectionModal() {
                await this.getSuppliers()
                this.$refs.supplierSelectionModal.show()
            },
            async createNewSupplier() {
                const { supplier, email, phone, supplier_representatives } = this.newSupplier;
                if (!phone && !email) {
                    this.newSupplier.error = 'Add a phone number or an email.';
                    return;
                }
                this.newSupplier.saving = true;
                this.newSupplier.error = '';
                try {
                    const { data } = await axios.post('/api/new-supplier', { supplier, email, phone, supplier_representatives });
                    // The API answers 200 with type "error" when it refuses.
                    if (data.type !== 'success' || !data.supplier) {
                        this.newSupplier.error = data.message || 'Could not add the supplier.';
                        return;
                    }
                    this.supplierDetails.selectedSupplier = data.supplier;
                    this.bulkRestock.supplier = data.supplier.id;
                    this.$refs.newSupplierModal.hide();
                    this.$refs.supplierSelectionModal.hide();
                    this.$toasts.push({ type: 'success', message: `Supplier ${data.supplier.supplier} added` });
                    this.getSuppliers();
                } catch (e) {
                    this.newSupplier.error = e.response?.data?.message || 'Could not add the supplier.';
                } finally {
                    this.newSupplier.saving = false;
                }
            },
            rowSelectSupplier(supplier) {
                this.supplierDetails.selectedSupplier = supplier
                this.bulkRestock.supplier = supplier.id
                this.$refs.supplierSelectionModal.hide()
            },
            resetSupplier() {
                this.supplierDetails.selectedSupplier = {}
                this.supplierDetails.searchTerm = ''
                this.$refs.supplierSelectionModal.show()
            },
            searchSupplier() {
                const searchTerm = this.supplierDetails.searchTerm.toLowerCase();
                this.supplierDetails.filteredSuppliers = this.supplierDetails.supplier.filter(supplier =>
                    (supplier.supplier && supplier.supplier.toLowerCase().includes(searchTerm)) ||
                    (supplier.email && supplier.email.toLowerCase().includes(searchTerm)) ||
                    (supplier.phone && supplier.phone.includes(searchTerm))
                );
            },
            openAddSupplierModal() {
                this.newSupplier = { supplier: this.supplierDetails.searchTerm, email: '', phone: '', supplier_representatives: { name: '', phone: '' }, error: '', saving: false };
                this.$refs.newSupplierModal.show()
            },
            reviewRestock() {
                if (!this.bulkRestock.itemsToRestock.length) return;
                this.$refs.reviewModal.show();
            },
            formatTime(t) {
                return t ? moment(t).format('DD MMM, HH:mm') : '';
            },
            // ---- Drafts (autosave) ----
            draftPayload() {
                return {
                    bulkRestock: this.bulkRestock,
                    supplier: this.supplierDetails.selectedSupplier,
                    cols: this.cols,
                };
            },
            scheduleDraftSave() {
                if (this.draft.loading || this.requisition) return;
                clearTimeout(this.draft.timer);
                this.draft.timer = setTimeout(this.saveDraft, 2000);
            },
            async saveDraft() {
                if (!this.bulkRestock.itemsToRestock.length) return;
                try {
                    const { data } = await axios.post('/api/bulk-restock-drafts', {
                        id: this.draft.id,
                        payload: JSON.parse(JSON.stringify(this.draftPayload())),
                        item_count: this.bulkRestock.itemsToRestock.length,
                        total: Number(this.totalBuyingSum) || 0,
                    });
                    const isNew = !this.draft.id;
                    this.draft.id = data.id;
                    this.draft.savedAt = data.saved_at;
                    if (isNew) this.loadDrafts();
                } catch (e) { /* autosave is best effort */ }
            },
            async loadDrafts() {
                try { this.drafts = (await axios.get('/api/bulk-restock-drafts')).data || []; } catch (e) { this.drafts = []; }
            },
            async continueDraft(id) {
                try {
                    const { data } = await axios.get(`/api/bulk-restock-drafts/${id}`);
                    this.draft.loading = true;
                    const p = data.payload || {};
                    Object.assign(this.bulkRestock, p.bulkRestock || {});
                    this.supplierDetails.selectedSupplier = p.supplier || {};
                    if (p.cols) this.cols = Object.assign({ sp: false, wsp: false }, p.cols);
                    this.draft.id = data.id;
                    this.draft.savedAt = data.updated_at;
                    this.$nextTick(() => { this.draft.loading = false; if (this.bulkRestock.itemsToRestock.length) this.openDrawer(true); });
                } catch (e) {
                    this.$toasts.push({ type: 'error', message: 'Could not open that draft.' });
                }
            },
            async discardDraft(id) {
                const ok = await this.$bvModal.msgBoxConfirm('Discard this saved restock list?', { okTitle: 'Discard', okVariant: 'danger', cancelVariant: 'outline-secondary', centered: true });
                if (!ok) return;
                try {
                    await axios.delete(`/api/bulk-restock-drafts/${id}`);
                    if (id === this.draft.id) { this.draft.id = null; this.draft.savedAt = null; }
                    this.loadDrafts();
                } catch (e) { /* ignore */ }
            },
            async completeRestock() {
                const missingVariant = this.bulkRestock.itemsToRestock.find(i => i.has_variants && !i.variant_id);
                if (missingVariant) {
                    this.$toasts.push({ type: 'error', message: `Select which variant you're restocking for "${missingVariant.product}"` });
                    return;
                }

                this.confirmIsNotComplete = false
                this.bulkRestock.totalAmount = this.totalBuyingSum;
                await axios.post('/api/purchases', { ...this.bulkRestock
                }).then(results => {
                    if (results.status === 200) {
                        if (this.draft.id) axios.delete(`/api/bulk-restock-drafts/${this.draft.id}`).catch(() => {});
                        productCacheService.hotReloadLocalDB().catch(e => console.warn('POS cache refresh failed:', e.message))
                        window.location.replace('/inventory')
                    }
                }).catch(error => {
                    const message = (error.response && error.response.data && (error.response.data.error || error.response.data.message)) || "There was an error"
                    this.$toasts.push({
                        'type': 'error',
                        'message': message
                    })
                    this.confirmIsNotComplete = true
                })
            },
            // Whole row toggles the item in/out of the restock list.
            toggleRestockItem(item) {
                const i = this.bulkRestock.itemsToRestock.indexOf(item);
                if (i === -1) this.bulkRestock.itemsToRestock.push(item);
                else this.bulkRestock.itemsToRestock.splice(i, 1);
            },
            searchItemAddToList(item) {
                if (!this.bulkRestock.itemsToRestock.includes(item)) {
                    this.bulkRestock.itemsToRestock.push(item)
                    this.itemsSearched = {}
                } else {
                    const index = this.bulkRestock.itemsToRestock.indexOf(item);
                    if (index !== -1) {
                        this.bulkRestock.itemsToRestock.splice(index, 1);
                        this.itemsSearched = {}
                    }
                }
            },
            async getSuppliers() {
                await axios.get('/api/all-suppliers')
                    .then(result => {
                        this.supplierDetails.supplier = result.data;
                        this.supplierDetails.supplier.supplier_representatives = {};
                    });
            },
        },
    }
</script>

<style>
/* Restock drawer (class names unique to this page: this block is unscoped). */
.restock-drawer { transition: width .25s ease; }
.restock-drawer-item { cursor: pointer; }
.restock-drawer-item:hover { background: #f8f9fa; }
.restock-lot { max-width: 260px; }
.restock-drawer-tab {
    position: fixed; right: 0; top: 45%; z-index: 1030;
    border-radius: 8px 0 0 8px; padding: 10px 8px;
    display: flex; flex-direction: column; align-items: center; gap: 6px;
    box-shadow: -2px 2px 8px rgba(0,0,0,.15);
}
.restock-drawer-tab-label { writing-mode: vertical-rl; transform: rotate(180deg); font-size: 13px; }
/* Clear the app's floating action button (bottom right). */
.restock-drawer-footer { padding-bottom: 88px !important; }

    .list-search-item {
        margin: 0.5em 0 0.5em 0;
        padding: 0;
    }
    small {
        font-size: 11px !important;
    }
    #customdropzone {
        min-width: 320px;
        min-height: 180px;
    }
</style>
